// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/poll_response/v1/poll_response.proto (package fingertip.creator.poll_response.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { PollResponseItem } from "../../../common/type/v1/poll_response_pb.js";

/**
 * @generated from message fingertip.creator.poll_response.v1.UpdatePollResponseRequest
 */
export const UpdatePollResponseRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.poll_response.v1.UpdatePollResponseRequest",
  () => [
    { no: 1, name: "poll_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "poll_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.poll_response.v1.UpdatePollResponseResponse
 */
export const UpdatePollResponseResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.poll_response.v1.UpdatePollResponseResponse",
  () => [
    { no: 1, name: "poll_response", kind: "message", T: PollResponseItem },
  ],
);

/**
 * @generated from message fingertip.creator.poll_response.v1.CreatePollResponseRequest
 */
export const CreatePollResponseRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.poll_response.v1.CreatePollResponseRequest",
  () => [
    { no: 1, name: "response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "poll_option_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.poll_response.v1.CreatePollResponseResponse
 */
export const CreatePollResponseResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.poll_response.v1.CreatePollResponseResponse",
  () => [
    { no: 1, name: "poll_response", kind: "message", T: PollResponseItem },
  ],
);

/**
 * @generated from message fingertip.creator.poll_response.v1.DeletePollResponseRequest
 */
export const DeletePollResponseRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.poll_response.v1.DeletePollResponseRequest",
  () => [
    { no: 1, name: "poll_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.poll_response.v1.DeletePollResponseResponse
 */
export const DeletePollResponseResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.poll_response.v1.DeletePollResponseResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

